import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import messages from './FeaturedNews.intl';

//styles
import styles from './FeaturedNews.module.scss';

//components
import NewsBoxSm from '../NewsBoxSm/NewsBoxSm';
import NewsStore from 'stores/News.store';

import Placeholder from 'common/components/Placeholder/Placeholder';
import ArticleSmall from 'common/components/Placeholder/components/ArticleSmall/ArticleSmall';

@injectIntl
export default class FeaturedNews extends Component {
  static propTypes = {
    className: PropTypes.string,
    activeNewsID: PropTypes.string
  };

  activeYear = null;
  state = {
    featuredNews: []
  };

  async fetchFeatured() {
    const featuredNews = await NewsStore.fetchFeaturedNews();
    this.setState({
      featuredNews
    });
  }

  componentDidMount() {
    this.fetchFeatured();
  }

  render() {
    const featuredNews = this.state.featuredNews.filter(
      el => el.system.id !== this.props.activeNewsID
    );

    return (
      <Placeholder
        component={<ArticleSmall className={styles.ArticleSmall} />}
        repeat={3}
        ready={!!featuredNews.length}
      >
        <div className={styles.SidebarFileToDownload}>
          <h3 className={styles.SidebarTitle}>
            {this.props.intl.formatMessage(messages.similarNews)}
          </h3>
          {featuredNews.map(news => <NewsBoxSm key={news.id} news={news} />)}
        </div>
      </Placeholder>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/News/components/FeaturedNews/FeaturedNews.js